import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  host: { 'class': 'app-button-group' },
  selector: 'app-button-group',
  styleUrls: ['./app-button-group.component.scss'],
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None,
})
export class AppButtonGroupComponent { }
